import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AnimateOnScrollDirective } from '../../directives/animate-on-scroll.directive';

interface PricingPlan {
  key: string;
  isPopular: boolean;
  buttonClass: string;
}

@Component({
    selector: 'app-pricing',
    imports: [CommonModule, TranslateModule, AnimateOnScrollDirective],
    templateUrl: './pricing.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./pricing.component.scss']
})
export class PricingComponent {
  plans: PricingPlan[] = [
    {
      key: 'initial',
      isPopular: false,
      buttonClass: 'btn-primary'
    },
    {
      key: 'medium',
      isPopular: true,
      buttonClass: 'btn-accent'
    },
    {
      key: 'full',
      isPopular: false,
      buttonClass: 'btn-primary'
    }
  ];
} 